<template>
  <v-app>
    <v-content>
      <div class="section s-1">
        <v-row class="height-p">
          <v-col class="flex">
            <div class="text-center">
              <h1 class="c-title">Heiisen</h1>
              <br />
              <v-btn href="https://instagram.com/heiiisen/">
                Instagram
                <v-icon right>mdi-instagram</v-icon>
              </v-btn>&nbsp;
              <v-btn href="mailto:louis.gautier02@gmail.com">
                Mail
                <v-icon right>mdi-gmail</v-icon>
              </v-btn>&nbsp;
              <v-btn href="https://discord.gg/GxWAfmJ">
                Discord
                <v-icon right>mdi-discord</v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col class="flex">
            <img class="logo" src="/heiisen.gif" />
          </v-col>
        </v-row>
        <div class="text-center">
          <img class="chevron" src="/chevron.png" />
        </div>
      </div>
      <div class="section s-2">
        <v-container class="height-p" fluid>
          <h1 class="title-sub">Logo Lycée Charlotte Perriand</h1>
          <v-row>
            <v-col class="flex">
              <div class="text-center">
                <a href="/charlottefond.png">
                  <img class="fond elevation-3 zoom" src="/charlottefond.png" />
                </a>
              </div>
            </v-col>
            <v-col class="flex">
              <div class="c-text-justify">
                <p>
                  Modernisation du logo du Lycée Charlotte Perriand située à Genech, 59242,
                  en utilisant l’outil de dessin vectoriel Adobe Illustrator.
                </p>
              </div>
            </v-col>
          </v-row>
        </v-container>
        <div class="text-center">
          <img class="chevron" src="/chevron.png" />
        </div>
      </div>
      <div class="section s-3">
        <v-container fluid>
          <h1 class="title-sub">Création de Curriculum vitæ</h1>
          <v-row class="fill-height">
            <v-col class="flex">
              <div class="c-text-justify force-right">
                <p>Création de CV sur l’outil de dessin graphique Adobe Photoshop, pour usage personnel ou à destination d’amis</p>
              </div>
            </v-col>
            <v-col class="flex">
              <div class="text-center">
                <a href="/CVbleu-min.jpg">
                  <img class="cv zoom" src="/CVbleu-min.jpg"/>
                </a>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <v-footer dark>
        <v-spacer />
        <span>
          2020 &copy; Heiisen &bullet;
          <a
            class="white--text"
            href="mailto:louis.gautier02@gmail.com"
          >Contact</a>
        </span>
        <v-spacer />
      </v-footer>
    </v-content>
  </v-app>
</template>

<style scoped>
html,
body,
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Montserrat", sans-serif !important;
  font-weight: 500;
}

h1 {
  margin: 0;
}

.chevron {
  height: 48px;
  width: 48px;
}

.section {
  color: white;
  height: 95vh;
  width: 100vw;
}

.s-1 {
  background: #41b883;
}

.s-2 {
  background: #ff5f45;
}

.s-3 {
  background: #0798ec;
}

.c-title {
  font-weight: 700;
  font-size: 38pt;
  font-family: "Montserrat", sans-serif !important;
}

.title-sub {
  font-weight: 700;
  font-size: 24pt;
  font-family: "Montserrat", sans-serif !important;
  padding: 2%;
  background: transparent;
}

.height-p {
  height: 80vh;
}

.c-text-justify {
  width: 70vmin;
  text-align:center, justify ;
  font-size: 1.320em;
}

.fond {
  width: 75vmin;
  background: white;
  padding: 5px;
  border-radius: 5px;
}

.cv {
  height: 65vmin;
  padding: 5px;
  border-radius: 5px;
}

.logo {
  height: 370px;
  width: auto;
}

.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}


.zoom {
  transition: transform .2s; /* Animation */
}

.zoom:hover {
  transform: scale(1.1); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}


.force-left {
  justify-content: left !important;
}

.force-right {
  justify-content: right !important;
}
</style>

<script>
export default {
  data() {
    return {
      options: {
        licenseKey: "NO_KEY"
      }
    };
  }
};
</script>
